const config = {
  toolbar: [
    "link",
    "unLink",
    "|",
    "table",
    "picture",
    "|",
    "fullscreen",
    "|",
    "sourceCode",
    "|",
    "bold",
    "italic",
    "strikeThrough",
    "removeFormat",
    "|",
    "insertUnorderedList",
    "insertOrderedList",
    "indent",
    "outdent",
    "|",
    "element"
  ]
};

export default config;
